<template>
  <ais-instant-search
    :index-name="indexName"
    :search-client="searchClient"
    data-test="algolia-search"
  >
    <ais-configure v-bind="searchConfigure" />
    <ais-autocomplete :escape-h-t-m-l="false" data-test="algolia-result">
      <template #default="{ currentRefinement, indices, refine }">
        <div>
          <input
            type="search"
            :value="currentRefinement"
            :placeholder="$t('Search for question…')"
            @input="refine($event.currentTarget.value)"
          />
          <ul v-if="currentRefinement" class="algolia-autocomplete">
            <template v-for="hit in indices[0].hits" :key="hit.objectID">
              <li>
                <nuxt-link
                  :to="
                    $puLocalePath({
                      name: 'about-faqs-slug',
                      params: { slug: hit.slug },
                    })
                  "
                >
                  <h4
                    v-thtml="hit._highlightResult.name.value"
                    class="search-result-title"
                  />
                  <div
                    v-thtml="hit._highlightResult.answer.value"
                    class="search-result-answer"
                  />
                </nuxt-link>
              </li>
            </template>
          </ul>
        </div>
      </template>
    </ais-autocomplete>
  </ais-instant-search>
</template>

<script lang="ts">
import { liteClient } from 'algoliasearch/lite'
import {
  AisAutocomplete,
  AisConfigure,
  AisHighlight,
  AisInstantSearch,
} from 'vue-instantsearch/vue3/es'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

const HITS_PER_PAGE = 10

@Component({
  components: {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Algolia component types are not fully typed
    AisAutocomplete,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Algolia component types are not fully typed
    AisConfigure,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Algolia component types are not fully typed
    AisHighlight,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Algolia component types are not fully typed
    AisInstantSearch,
  },
})
class AlgoliaSearch extends Vue {
  @Prop()
  categories: number[]

  get searchClient() {
    return liteClient(
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Runtime config types are not fully typed
      this.$config.public.algoliaAppId,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Runtime config types are not fully typed
      this.$config.public.algoliaApiKey,
    )
  }

  get searchConfigure() {
    return {
      highlightPreTag: '<mark>',
      highlightPostTag: '</mark>',
      hitsPerPage: HITS_PER_PAGE,
      filters: this.categories
        ? this.categories.map((c) => `categories=${c}`).join(' OR ')
        : '',
    }
  }

  get indexName() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- i18n localeInfo types are not fully typed
    const locale = this.$i18n.localeInfo.code
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Runtime config types are not fully typed
    return `${this.$config.public.algoliaIndexPrefix}faq_${locale}`
  }
}

export default toNative(AlgoliaSearch)
</script>
<style scoped>
.algolia-autocomplete {
  background-color: #fff;
  border: 1px solid #999;
  width: calc(100vw - 2em);
}

.algolia-autocomplete li {
  padding: 0.7em;
  border-top: 1px solid #999;
}

.algolia-autocomplete li a {
  text-decoration: none;
}

.search-result-title {
  font-weight: 700;
  font-size: 1.4em;
  display: block;
  line-height: 1.1;
}

.search-result-answer :deep(img) {
  display: none;
}

.search-result-answer :deep(a) {
  text-decoration: none;
  color: inherit;
  font-weight: 400;
}

.search-result-title :deep(mark),
.search-result-answer :deep(mark) {
  background: #ff0;
}
</style>
